import React from 'react';
import ChangeClientPrice from '../../../general/ChangeClientPrice.react';
import BookingsActions from '../../../../actions/BookingsActions';
import SettlePaymentHotelSummary from './SettlePaymentHotelSummary';
import SettlePaymentEditCommissionMulti from './SettlePaymentEditCommissionMulti.react';

const SettlePaymentEditCommission = ({ profile, booking, bookings, isMultiMode, onClose, chargeCurrency }) => {
	const onUpdate = (agentPricing) => {
		BookingsActions.updateAgentPricing(booking, agentPricing);
		onClose();
	};

	if (isMultiMode && Array.isArray(bookings) && bookings.length > 1) {
		return <SettlePaymentEditCommissionMulti bookings={bookings} onClose={onClose} />;
	}

	return (
		<div className="settle-payment-wrap">
			<div className="settle-payment-edit-commission change-client-price">
				<ChangeClientPrice
					deal={booking?.deal}
					initializing={false}
					disabled={false}
					onCancel={onClose}
					onUpdate={onUpdate}
					profile={profile}
					sellInNetPriceOption={true}
					chargeCurrency={chargeCurrency}
					payMode={true}
				/>
			</div>
			<SettlePaymentHotelSummary booking={booking} />
		</div>
	);
};

export default SettlePaymentEditCommission;
